import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ConnectionStatus } from '@capacitor/network';
import { fromEvent, map, merge, Observable, startWith } from 'rxjs';

/**
 * Plain browser online/offline status, with no NgRx and no other service
 * dependency — factored out of LocalStatusFacade so AuthService (which
 * LocalStatusFacade itself depends on, for loggedIn$/userId$) can also read
 * connectivity (for token-renewal gating) without a DI cycle.
 */
@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
  private readonly platformId = inject(PLATFORM_ID);

  readonly status$: Observable<ConnectionStatus> = isPlatformBrowser(this.platformId)
    ? merge(fromEvent(window, 'online'), fromEvent(window, 'offline')).pipe(
        map(() => ({ connected: navigator.onLine, connectionType: 'unknown' as const })),
        startWith({ connected: navigator.onLine, connectionType: 'unknown' as const }),
      )
    : new Observable<ConnectionStatus>((subscriber) => subscriber.next({ connected: true, connectionType: 'unknown' }));
}
